// Instagram API Credentials
// These should be loaded from environment variables in production
// Never commit actual credentials to version control

export const INSTAGRAM_USER_ID = process.env.REACT_APP_INSTAGRAM_USER_ID || '17841403056433385';
export const ACCESS_TOKEN = process.env.REACT_APP_INSTAGRAM_ACCESS_TOKEN || 'EAAUYoZCZBlyHcBRM05hEKrsPG9rWNZAdJl9P3tBNQmsU6dNUn3kUEfutoOx6ZBhk37tXOk1IIBY66YbH4U5Q3A6FxtpA41trUeQZAegBWB2jTm8Bcffyd2kxMUUBwI6kNfCF4HcZAoXb3tOCXz2yPD96V3Q7F1MI90CIcS5Xt7vjnMQhIlERmtzt2GdXpSnMTkFruEgx7j57h2qwvb';
